"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighchartsComponentWrapper = void 0;
const React = __importStar(require("react"));
const HighchartsWithOptionsComponent_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsWithOptionsComponent");
const lodash_1 = __importDefault(require("lodash"));
const antd_1 = require("antd");
const HighchartsComponentWrapper = ({ highchartsOptionsState, inProgress, chartIdentifier, chartHeight }) => {
    // console.log("HighchartsComponentWrapper.render: ", _.cloneDeep(highchartsOptionsState.chartStatus));
    let overlay = null;
    if (inProgress) {
        overlay = React.createElement(antd_1.Spin, null);
    }
    else if (highchartsOptionsState.error.isError) {
        overlay = React.createElement(antd_1.Alert, { type: "error", message: React.createElement(React.Fragment, null, `${highchartsOptionsState.error.error}`), showIcon: true });
    }
    else if (!lodash_1.default.isNil(highchartsOptionsState.chartStatus)) {
        switch (highchartsOptionsState.chartStatus.status) {
            case "unknown":
                overlay = React.createElement(antd_1.Alert, { type: "warning", message: highchartsOptionsState.chartStatus.status, showIcon: true });
                break;
            case "notLoaded":
                overlay = React.createElement(antd_1.Alert, { type: "warning", message: "Please specify the parameters below.", showIcon: true });
                break;
            case "inProgress":
                overlay = React.createElement(antd_1.Alert, { type: "warning", message: highchartsOptionsState.chartStatus.status, showIcon: true });
                break;
            case "loaded":
                break;
            case "parametersChanged":
                overlay = React.createElement(antd_1.Alert, { type: "warning", message: "Chart parameters changed, please press the SHOW button below.", showIcon: true });
                break;
            case "parametersChangedButEmpty":
                overlay = React.createElement(antd_1.Alert, { type: "warning", message: "Chart parameters changed, please select event name.", showIcon: true });
                break;
            case "noData":
                overlay = React.createElement(antd_1.Alert, { type: "warning", message: "No data to show. Please change filter.", showIcon: true });
                break;
            case "error":
                overlay = React.createElement(antd_1.Alert, { type: "error", message: React.createElement(React.Fragment, null, `${highchartsOptionsState.chartStatus.error}`), showIcon: true });
                break;
        }
        // overlay = <Alert type="warning" message={<>Something went wrong<br/>Please try again</>} showIcon/>
    }
    else if (lodash_1.default.isEmpty(highchartsOptionsState.options)) {
        // console.log("HighchartsComponentWrapper.render no chartStatus");
        overlay = React.createElement(antd_1.Alert, { type: "warning", message: "No Data", showIcon: true });
        // overlay = <Alert type="warning" message={<>Something went wrong<br/>Please try again</>} showIcon/>
    }
    const hasOverlay = !lodash_1.default.isEmpty(overlay);
    return React.createElement("div", { className: "highchartsChart" + (hasOverlay ? " highchartsChartMasked" : "") },
        React.createElement("div", { className: "highchartsChartChart" },
            React.createElement(HighchartsWithOptionsComponent_1.HighchartsWithOptionsComponent, { options: highchartsOptionsState.options, chartIdentifier: chartIdentifier, chartHeight: chartHeight })),
        hasOverlay && React.createElement("div", { className: "highchartsChartOverlay" }, overlay));
};
exports.HighchartsComponentWrapper = HighchartsComponentWrapper;
